module.exports = __webpack_public_path__ + "static/img/M-3.b548605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/M-3.png
// module id = Vrlo
// module chunks = 0